import React from "react";
import DefaultBlock from "../../components/main/DefaultBlock";
import { Grid, Typography } from "@mui/material";
import { Button, Box } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Link as RouterLink } from "react-router-dom";

import BlueprintBlock from "../../components/main/BlueprintBlock";
import Profile from "../../components/main/Profile";
import GitHubIcon from "@mui/icons-material/GitHub";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { IconButton, Tooltip } from "@mui/material";
import BlogColumn from "../../components/main/BlogColumn";
import ImageExperienceCard from "../../components/experience/ImageExperienceCard";

import LaunchIcon from "@mui/icons-material/Launch";
import SEO from "../../components/misc/SEO";

const experienceData = [
  {
    logoSrc: "/p/guy_orig.png",
    company: "Character Design",
    subtitle: "Demo Reel",
    link: "https://youtu.be/hE5A26eLJwY?si=iFH-ina9WdnfAPn8",

    description:
      "For Civil, I created base character meshes divided into three modular components: legs, torso, and head. These parts could be swapped out to customize player clothing, and each mesh included morph targets for facial expressions, gender-specific features, and more.",
  },
  {
    logoSrc: "/p/g-clock2_orig.png",
    company: "Character Design",
    subtitle: "Demo Reel",
    link: "https://youtu.be/hE5A26eLJwY?si=iFH-ina9WdnfAPn8",

    description:
      "For Civil, I also designed a variety of props. Many were static, while others were breakable and dynamic, complete with gibs. I modeled these props in Blender using real-world reference photos and textured them in Substance Painter.​",
  },
  {
    logoSrc: "/p/g-gun_orig.png",
    company: "Character Design",
    subtitle: "Demo Reel",
    link: "https://youtu.be/hE5A26eLJwY?si=iFH-ina9WdnfAPn8",

    description:
      "I designed a diverse range of weapons for Civil, modeling them in Blender based on real-world reference photos and texturing them in Substance Painter. Each weapon was composed of multiple modular parts, which could be assembled into a functional weapon object in Unreal Engine. These objects supported firing and reloading animations, as well as customizable muzzle flash effects.",
  },
];

export default function ThreeDPort() {
  return (
    <div>
      <SEO
        title="Portfolio | Aaron Hunt"
        image="https://www.aaronhunt.dev/p/cvl.jpg"
      />
      <BlueprintBlock text="export default 3D {" />
      <DefaultBlock>
        <Grid container sx={{ width: "100%" }}>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              width: { md: "50%" },
              boxSizing: "border-box",
              pr: { md: 1 },
            }}
          >
            <Box
              sx={{
                py: 8,
                px: 2,
                pb: "20px",
                backgroundColor: "transparent",
                textAlign: "left",
                maxWidth: "100%",
              }}
            >
              <Typography sx={{ pb: 2, maxWidth: "512px", opacity: 0.5 }}>
                Aaron Hunt
              </Typography>
              <Typography variant="h2" fontWeight="bold">
                Junior 3D Artist
              </Typography>
              <Typography sx={{ pt: 2, maxWidth: "512px", opacity: 0.8 }}>
                With 5+ years in 3D game art, I craft models that bring your
                worlds to life.
              </Typography>
            </Box>

            <Box sx={{ px: 2, mt: 3, display: "flex", gap: 2 }}>
              {[
                {
                  label: "Watch Videos",
                  to: "https://www.youtube.com/playlist?list=PLKeAe3q9q9hDsyxhWGfLRXBmn7bW2VUNL",
                  color: "primary",
                },

                { label: "About Me", to: "/blog/about-me", color: "secondary" },
              ].map(({ label, to, color }) => (
                <Button
                  key={label}
                  variant="contained"
                  color={color}
                  target="_blank"
                  component={RouterLink}
                  to={to}
                  endIcon={<ArrowForwardIosIcon sx={{ height: 14 }} />}
                  sx={{
                    position: "relative",
                    overflow: "hidden",
                    transition: "all 0.3s ease",
                    "& .MuiButton-endIcon": {
                      opacity: 0.5,
                      transform: "translateX(-2px)",
                      transition: "all 0.3s ease",
                    },
                    "&:hover .MuiButton-endIcon": {
                      opacity: 1,
                      transform: "translateX(2px)",
                    },
                  }}
                >
                  {label}
                </Button>
              ))}
            </Box>
            <Box sx={{ display: "flex", gap: 1.5, px: 2, mt: 4, opacity: 0.6 }}>
              <Tooltip title="GitHub">
                <IconButton
                  component="a"
                  href="https://github.com/anhuntz/aaron-hunt-portfolio"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="inherit"
                >
                  <GitHubIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="LinkedIn">
                <IconButton
                  component="a"
                  href="https://www.linkedin.com/in/aaron-h-36332412b/"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="inherit"
                >
                  <LinkedInIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="YouTube">
                <IconButton
                  component="a"
                  href="https://www.youtube.com/@aaronhunt7204"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="inherit"
                >
                  <YouTubeIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Blog">
                <IconButton
                  component="a"
                  href="/blog"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="inherit"
                >
                  <img
                    src="/logo.svg"
                    alt="Custom Icon"
                    style={{ height: 24, width: 24 }}
                  />
                </IconButton>
              </Tooltip>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              width: { md: "50%" },
              boxSizing: "border-box",
              pl: { md: 1 },
            }}
          >
            <Profile />
          </Grid>
        </Grid>
      </DefaultBlock>
      <BlueprintBlock text="load portfolio" />

      <DefaultBlock>
        <Typography variant="h5" sx={{ p: 2, maxWidth: "512px", opacity: 0.8 }}>
          Videos
        </Typography>
        <Box className="backgroundDots">
          <Grid
            container
            spacing={3}
            justifyContent="center"
            sx={{ maxWidth: 1200, mx: "auto", pt: 2 }}
          >
            {["hE5A26eLJwY", "eTLD0rYwnPY"].map((videoId) => (
              <Grid
                item
                key={videoId}
                sx={{
                  width: "100%",
                  maxWidth: 460,
                  flexGrow: 1,
                }}
              >
                <Box
                  sx={{
                    aspectRatio: "16 / 9",
                    width: "100%",
                    overflow: "hidden",
                    borderRadius: 2,
                    boxShadow: 1,
                    mb: 2,
                  }}
                >
                  <iframe
                    src={`https://www.youtube.com/embed/${videoId}`}
                    title={`YouTube video ${videoId}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                      width: "100%",
                      height: "100%",
                      border: 0,
                      display: "block",
                    }}
                  />
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </DefaultBlock>

      <BlueprintBlock text="load previous.work" />
      <DefaultBlock>
        {" "}
        <Typography variant="h5" sx={{ p: 2, maxWidth: "512px", opacity: 0.8 }}>
          Work Examples
        </Typography>
        <Box className="backgroundGrid" sx={{ p: 2 }}>
          {experienceData.map((exp, index) => (
            <Box sx={{ mb: 2 }}>
              <ImageExperienceCard
                key={index}
                logoSrc={exp.logoSrc}
                company={exp.company}
                subtitle={exp.subtitle}
                link={exp.link}
                time={exp.time}
                description={exp.description}
              />
            </Box>
          ))}
        </Box>
      </DefaultBlock>
      <BlueprintBlock text="load projects(type: 3D)" />
      <DefaultBlock>
        <Typography variant="h5" sx={{ p: 2, maxWidth: "512px", opacity: 0.8 }}>
          Other Relevant Projects
        </Typography>
        <BlogColumn showProjects={true} limit={5} category="3d" />
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <Button
            variant="contained"
            color="secondary"
            href="/blog"
            rel="noopener noreferrer"
            startIcon={<LaunchIcon />}
            sx={{ mt: 2, mb: 3 }}
          >
            View More Projects
          </Button>
        </Box>
      </DefaultBlock>
    </div>
  );
}
